module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-app-bar-title', {
    staticClass: "centered-title"
  }, [_vm._v(_vm._s(_vm.$t("IrrigationOrdersTable.irrigationOrders")) + " " + _vm._s(_vm.pageNumber))]), _vm._v(" "), (_vm.loading) ? _c('v-progress-circular', {
    staticClass: "loading-icon",
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "3",
      "color": "#0098E1"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 text-center table-content",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.dataTable,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([(!_vm.loading) ? {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.irrigationOrderId))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.deviceName))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.plotName))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.from))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.to))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.mm))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.theoricHours))]), _vm._v(" "), _c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(props.item.diffTimeHours))])]
      }
    } : null], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d212aa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/IrrigationOrdersTable.vue
// module id = 1689
// module chunks = 0